import { Button, ListGroup } from 'react-bootstrap';
import styles from '../../../../../styles/expenditureworksheet.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPenToSquare, faPlus } from '@fortawesome/free-solid-svg-icons';
import { ExepnditureAccordion, ExepnditureAccordionBody, ExepnditureAccordionCollapseSection, ExepnditureAccordionToggle } from '../expenditureaccordion';
import formatDollars from '../../../../../utilities/currency-formatter';
import useTestExpenditureData from '../../../../../testdata/expenditure/testexpenditurestore';
import DeleteButtonNonNetwork from '../../../../../components/deletebuttonnonnetwork';
import DeleteButton from '../../../../../components/deletebutton';
import useMessageStore from '../../../../../stores/message-store';

const ExpenditureProCard = ({ApplicationID, toggleAddEditMode, addEditIndex, proCards = [], expenditureTypemap,refreshFunction, canAdd = false, canUpdate = false, canDelete = false }) => {

    const _getExpenditureTypeText = (expenditureTypeId) => {
        if(expenditureTypeId === null)
            return <span>Type Missing</span>
        else
            return <span>{expenditureTypemap[expenditureTypeId]}</span>
    }

    const addToast = useMessageStore(state => state.addToast);

    const _deleteSuccessCallback = () => {
        addToast(
            {
                id: Math.random(),
                body: "The Procard entry was succesfully deleted!",
                autoHide: true,
                errorFlag: false,
                timestamp: Date.now() - 1000
            }
        )

        refreshFunction();
    }

    const _deleteErrorCallback = () => {
        addToast(
            {
                id: Math.random(),
                body: "An error occured when deleting the Procard entry.",
                autoHide: true,
                errorFlag: true,
                timestamp: Date.now() - 1000
            }
        )
    }

    const procardTotal = proCards.reduce((acc,item) => acc + item.amount,0);
    const showEmptyState = !canAdd && proCards.length === 0;

    return (
        <ExepnditureAccordion>
            <ExepnditureAccordionBody eventKey='0'>
                <ExepnditureAccordionToggle eventKey='0'>
                    <span className='d-flex justify-content-between align-items-center w-100'>
                        <span className='fw-bold'>PROCARD</span>
                        <span>{formatDollars(procardTotal)}</span>
                    </span>
                </ExepnditureAccordionToggle>
                <ExepnditureAccordionCollapseSection>
                    <ListGroup>
                        {
                            canAdd
                            ?
                                <ListGroup.Item className={`${styles.expenditureListItem}`}>
                                    <div className='d-flex justify-content-center'>
                                        <Button type='button' variant='success' size='sm' title='Add Procard Entry' aria-label='Add Procard Entry' style={{ borderRadius: '50%' }} onClick={() => toggleAddEditMode(null, addEditIndex, 'add')}>
                                            <FontAwesomeIcon icon={faPlus} />
                                        </Button>
                                    </div>
                                </ListGroup.Item>
                            :
                                null
                        }
                        {
                            showEmptyState
                            ?
                                <ListGroup.Item className={`${styles.expenditureListItem} text-center text-muted`}>
                                    No procard entries to display.
                                </ListGroup.Item>
                            :
                                null
                        }
                        {
                            proCards.map(proCard => {

                                return (
                                    <ListGroup.Item key={proCard.id} className={`${styles.expenditureListItem}`}>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <span>{formatDollars(proCard.amount)}</span>
                                            <span>{proCard.createddate}</span>
                                        </div>
                                        <div className={styles.expenditureListItemText}>
                                            {proCard.itempurpose}
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <span className={styles.expenditureListItemType}>
                                                {
                                                    _getExpenditureTypeText(proCard.expendituretypeid)
                                                }
                                            </span>
                                            <span className='d-flex'>
                                                <div>
                                                    <Button size="sm" type="button" variant="primary" className="me-1" title={canUpdate ? "Edit Procard Entry" : "View Procard Entry"} aria-label={canUpdate ? "Edit Procard Entry" : "View Procard Entry"} onClick={() => toggleAddEditMode(proCard.id, addEditIndex, canUpdate ? 'edit' : 'view')}>
                                                        <FontAwesomeIcon icon={canUpdate ? faPenToSquare : faEye} />
                                                    </Button>
                                                </div>
                                                {
                                                    canDelete
                                                    ?
                                                        <div >
                                                            <DeleteButton
                                                                deleteObject={{ApplicationID: ApplicationID,ProcardID: proCard.id}}
                                                                endpoint="ExpenditureWorksheet_Procard_Delete"
                                                                successCallback={_deleteSuccessCallback}
                                                                errorCallback={_deleteErrorCallback}
                                                            />
                                                        </div>
                                                    :
                                                        null
                                                }
                                            </span>
                                        </div>
                                    </ListGroup.Item>
                                );
                            })
                        }

                    </ListGroup>
                </ExepnditureAccordionCollapseSection>
            </ExepnditureAccordionBody>
        </ExepnditureAccordion>
    )
}

export default ExpenditureProCard;
